module.exports = __webpack_public_path__ + "img/2-supervalue-assist-menu.12750cb0.jpg";